import api from './api';
import { Video } from '../types';

export const videoService = {
  getCourseVideos: async (courseId: number) => {
    const response = await api.get<{ videos: Video[] }>(`/videos/course/${courseId}`);
    return response.data.videos;
  },

  getVideo: async (id: number) => {
    const response = await api.get<{ video: Video }>(`/videos/${id}`);
    return response.data.video;
  },

  uploadVideo: async (courseId: number, file: File, videoData: Partial<Video> & { thumbnailFile?: File; slideFile?: File; imageFiles?: File[] }) => {
    const formData = new FormData();
    formData.append('video', file);
    formData.append('title', videoData.title || '');
    formData.append('description', videoData.description || '');
    if (videoData.thumbnailFile) {
      formData.append('thumbnail', videoData.thumbnailFile);
    } else if (videoData.thumbnail) {
      formData.append('thumbnail', videoData.thumbnail);
    }
    if (videoData.slideFile) {
      formData.append('slide_file', videoData.slideFile);
    }
    if (videoData.duration) formData.append('duration', videoData.duration.toString());
    if (videoData.order) formData.append('order', videoData.order.toString());
    if (videoData.chapter_id) formData.append('chapter_id', videoData.chapter_id.toString());
    if (videoData.slide_url !== undefined) formData.append('slide_url', videoData.slide_url || '');
    if (videoData.slides && Array.isArray(videoData.slides)) {
      formData.append('slides', JSON.stringify(videoData.slides));
    }
    if (videoData.images && Array.isArray(videoData.images)) {
      formData.append('images', JSON.stringify(videoData.images));
    }
    if (videoData.imageFiles && Array.isArray(videoData.imageFiles)) {
      videoData.imageFiles.forEach((file) => {
        formData.append('image_files', file);
      });
    }

    const response = await api.post<{ message: string; video: Video }>(
      `/videos/course/${courseId}`,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }
    );
    return response.data;
  },

  updateVideo: async (id: number, videoData: Partial<Video> & { thumbnailFile?: File; videoFile?: File; slideFile?: File; imageFiles?: File[] }) => {
    const formData = new FormData();
    
    if (videoData.videoFile) {
      formData.append('video', videoData.videoFile);
    }
    if (videoData.thumbnailFile) {
      formData.append('thumbnail', videoData.thumbnailFile);
    }
    if (videoData.slideFile) {
      formData.append('slide_file', videoData.slideFile);
    }
    if (videoData.title !== undefined) formData.append('title', videoData.title);
    if (videoData.description !== undefined) formData.append('description', videoData.description || '');
    if (videoData.duration !== undefined) formData.append('duration', videoData.duration.toString());
    if (videoData.order !== undefined) formData.append('order', videoData.order.toString());
    if (videoData.chapter_id !== undefined) formData.append('chapter_id', videoData.chapter_id?.toString() || '');
    if (videoData.slide_url !== undefined) formData.append('slide_url', videoData.slide_url || '');
    if (videoData.slides && Array.isArray(videoData.slides)) {
      formData.append('slides', JSON.stringify(videoData.slides));
    }
    if (videoData.images && Array.isArray(videoData.images)) {
      formData.append('images', JSON.stringify(videoData.images));
    }
    if (videoData.imageFiles && Array.isArray(videoData.imageFiles)) {
      videoData.imageFiles.forEach((file) => {
        formData.append('image_files', file);
      });
    }
    if (videoData.thumbnail && !videoData.thumbnailFile) {
      formData.append('thumbnail', videoData.thumbnail);
    }

    const response = await api.put<{ message: string; video: Video }>(
      `/videos/${id}`,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }
    );
    return response.data;
  },

  deleteVideo: async (id: number) => {
    const response = await api.delete<{ message: string }>(`/videos/${id}`);
    return response.data;
  },
};


